<template>
	<q-dialog
			:value="visible"
			@hide="hide"
			:full-width="true"
			square
	>
		<q-card class="pallet-log-list">
			<dialog-header :dialog-title="name" :raw-title="true" @close="hide" />
			<q-card-section>
				<pallet-log-list
						:pallet="pallet"
						@hide="hide"
				/>
			</q-card-section>
		</q-card>
	</q-dialog>
</template>

<script>
	import DialogHeader from "@/components/dialog/DialogHeader";
	import PalletLogList from "@/components/dialog/PalletLogList";

	export default {
		name: "PalletDialog",
		components: {PalletLogList, DialogHeader},
		props: ['visible', 'name', 'pallet'],
		methods: {
			hide() {
				this.$emit('hide');
			}
		}
	}
</script>

<style scoped>

</style>